import { idbGet, idbSet } from '../idbKvStore';

// Only cache JSON-serializable values (matches fetch().json() output)
type Json = null | boolean | number | string | Json[] | { [key: string]: Json };

const CACHE_PREFIX = 'apiCache';

const getCacheKey = (requestKey: string) => `${CACHE_PREFIX}:${requestKey}`;

const readApiCache = (key: string): Promise<Json | null> =>
  idbGet<Json>(key).then(val => val || null);

const writeApiCache = (key: string, body: Json): Promise<void> => idbSet<Json>(key, body);

export { getCacheKey, readApiCache, writeApiCache };
